export const cities = [
  { id: 1, cityName: "Split" },
  { id: 2, cityName: "Zagreb" },
  { id: 3, cityName: "Ljubljana" },
  { id: 4, cityName: "Beograd" },
  { id: 5, cityName: "Podgorica" },
  { id: 6, cityName: "Rijeka" },
  { id: 7, cityName: "Online" },
];
